var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{staticClass:"select-align-right",attrs:{"enum":_vm.tahsilHarciEnum,"labels":_vm.tahsilHarciLabel,"label":"Tahsil Harcı Oranı"},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }